export const OVERLAY_PANEL_RESIZE_HANDLE_CLASSES = {
  top: 'cursor-ns-resize',
  right: 'cursor-ew-resize',
  bottom: 'cursor-ns-resize',
  left: 'cursor-ew-resize',
  topLeft: 'cursor-nwse-resize',
  topRight: 'cursor-nesw-resize',
  bottomRight: 'cursor-nwse-resize',
  bottomLeft: 'cursor-nesw-resize',
} as const;

export const OVERLAY_PANEL_RESIZE_HANDLE_STYLES = {
  top: { height: '10px', top: '-5px' },
  right: { width: '10px', right: '-5px' },
  bottom: { height: '10px', bottom: '-5px' },
  left: { width: '10px', left: '-5px' },
  topLeft: { width: '14px', height: '14px', left: '-7px', top: '-7px' },
  topRight: { width: '14px', height: '14px', right: '-7px', top: '-7px' },
  bottomRight: { width: '14px', height: '14px', right: '-7px', bottom: '-7px' },
  bottomLeft: { width: '14px', height: '14px', left: '-7px', bottom: '-7px' },
} as const;
